import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";

// Built-in default R2 config (so deployed builds always work, even without .env)
const DEFAULT_R2_CONFIG = {
    accountId: "b962680fe908fbfcbef4abb29e472cf6",
    accessKeyId: "5cde9843c70b0ad06f361077650e4f70",
    secretAccessKey: "45b1bd25f3e950c5c9f86129c3568027c5db1f893b36ff8e26d5d705b171620c",
    bucket: "said",
    publicBaseUrl: "https://pub-89433de389d5418abd6651e75de20334.r2.dev",
};

function getEnvR2Config() {
    const cfg = {
        accountId: process.env.REACT_APP_R2_ACCOUNT_ID || DEFAULT_R2_CONFIG.accountId,
        accessKeyId: process.env.REACT_APP_R2_ACCESS_KEY_ID || DEFAULT_R2_CONFIG.accessKeyId,
        secretAccessKey: process.env.REACT_APP_R2_SECRET_ACCESS_KEY || DEFAULT_R2_CONFIG.secretAccessKey,
        bucket: process.env.REACT_APP_R2_BUCKET || DEFAULT_R2_CONFIG.bucket,
        publicBaseUrl: process.env.REACT_APP_R2_PUBLIC_BASE_URL || DEFAULT_R2_CONFIG.publicBaseUrl,
    };
    if (!cfg.accountId || !cfg.accessKeyId || !cfg.secretAccessKey || !cfg.bucket) {
        return null;
    }
    return cfg;
}

export function getR2Config() {
    try {
        const raw = localStorage.getItem("ka_r2_config");
        if (raw) {
            const cfg = JSON.parse(raw);
            if (cfg.accountId && cfg.accessKeyId && cfg.secretAccessKey && cfg.bucket) {
                return cfg;
            }
        }
    } catch {
        /* fall through to env/defaults */
    }
    return getEnvR2Config();
}

export function saveR2Config(cfg) {
    localStorage.setItem("ka_r2_config", JSON.stringify(cfg));
}

export function r2Ready() {
    return !!getR2Config();
}

function getClient(cfg) {
    return new S3Client({
        region: "auto",
        endpoint: `https://${cfg.accountId}.r2.cloudflarestorage.com`,
        credentials: {
            accessKeyId: cfg.accessKeyId,
            secretAccessKey: cfg.secretAccessKey,
        },
    });
}

export async function uploadToR2(file, keyPrefix = "uploads") {
    const cfg = getR2Config();
    if (!cfg) throw new Error("Cloudflare R2 konfiqurasiyası yoxdur");
    const client = getClient(cfg);
    const ext = (file.name?.split(".").pop() || "bin").toLowerCase();
    const key = `${keyPrefix}/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
    const arrayBuf = await file.arrayBuffer();
    await client.send(
        new PutObjectCommand({
            Bucket: cfg.bucket,
            Key: key,
            Body: new Uint8Array(arrayBuf),
            ContentType: file.type || "application/octet-stream",
        })
    );
    // Build public URL — use custom domain if provided, else default R2 public URL
    const base = cfg.publicBaseUrl
        ? cfg.publicBaseUrl.replace(/\/$/, "")
        : `https://pub-${cfg.accountId}.r2.dev/${cfg.bucket}`;
    return `${base}/${key}`;
}

/* Fallback for when R2 not configured — convert to data URL */
export function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export async function uploadImage(file) {
    if (r2Ready()) {
        try {
            return await uploadToR2(file, "images");
        } catch (e) {
            console.warn("R2 upload failed, falling back to dataURL", e);
        }
    }
    return await fileToDataUrl(file);
}
